
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrialSettingsProposal as ObiTrialSettingsProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-trial-settings-proposal.js';
 
 
 

 
 export const ObiTrialSettingsProposal = createComponent({
   react: React,
   tagName: 'obi-trial-settings-proposal',
   elementClass: ObiTrialSettingsProposalElement,
   events: {
     
   }
  });
 
 